import { autoinject } from 'aurelia-framework'
import { InstrumentTypesCache } from '@dynamik/common';
import { InstrumentTypeViewModel, InstrumentViewModel } from '@dynamik/common/clients/transaction-clients';
import { ExportExcelBase } from '../../classes/export-excel-base';
import { CellContextMenuEvent, ExcelExportParams, GetContextMenuItemsParams, ProcessCellForExportParams } from 'ag-grid-community';

@autoinject
export class ReportOverviewExportToExcel extends ExportExcelBase {
  instrumentTypes: InstrumentTypeViewModel[];

  constructor(private instrumentTypesCache: InstrumentTypesCache) {
    super();
    this.excelParams.fileName = 'ReportOverview';
    this.excelParams.sheetName = 'Overview';
    this.excelParams.processHeaderCallback = params => params.column.getColId() === 'instrumentId' ? 'ID' : params.column.getColDef().headerName;
  }

  export_securitiesTypeId(params: ProcessCellForExportParams<InstrumentViewModel>) {
    return this.instrumentTypes[params.value]?.name ?? '';
  }

  export_autoPriceStatus(params: ProcessCellForExportParams<InstrumentViewModel>) {
    switch (params.value) {
      case 1: return 'Imported price';
      default: return '';
    }
  }

  export_isin(params: ProcessCellForExportParams<InstrumentViewModel>) {
    return params.node?.data?.isin || params.node?.data?.orgNr || '';
  }

  async init() {
    this.instrumentTypes = [];
    (await this.instrumentTypesCache.instrumentTypes).forEach(x => this.instrumentTypes[x.id] = x);
  }

  override async getExportToExcelParams(params: GetContextMenuItemsParams | CellContextMenuEvent): Promise<ExcelExportParams> {
    const excelParams = await super.getExportToExcelParams(params);
    excelParams.columnKeys = params.api.getColumns().filter(x => x.isVisible() && !x.getColId().startsWith('uuid')).map(x => x.getColId());
    return excelParams;
  }

}
